export default __webpack_public_path__ + "static/media/881.1d33fdf8.gif";